export class HttpError extends Error {
    constructor(message, status, data) {
        super(message);
        this.status = status;
        this.data = data;
    }
    status;
    data;
}
export class DefaultResponseHandler {
    errors = {
        400: "リクエストが不正です",
        401: "認証が必要です",
        403: "アクセスが禁止されています",
        404: "リソースが見つかりません",
        405: "許可されていないHTTPメソッドです",
        406: "受理できないリクエストです",
        408: "リクエストがタイムアウトしました",
        500: "サーバでエラーが発生しました",
        503: "サービス利用不可"
    };
    handle(response, config) {
        if (!response) {
            throw this.error(500, "http request error.");
        }
        if (response.status !== 200) {
            this.handleError(response, config);
        }
        return this.data(response, config);
    }
    handleError(response, config) {
        let status = response.status;
        let message = this.errors[status] || response.statusText;
        throw this.error(status, message, response.data);
    }
    data(response, config) {
        if (response.data instanceof Blob) {
            return response.data;
        }
        if (!response.data) {
            return null;
        }
        // Result形式じゃない
        if (response.data.success == null) {
            return response.data;
        }
        let result = response.data;
        if (result.success) {
            return result;
        }
        throw this.error(response.status, result.errorMessage, result);
    }
    error(status, message, data = null) {
        return new HttpError(message, status, data);
    }
}
